var $d700c23c0c1b247b$exports = {};
$d700c23c0c1b247b$exports = {
    "breadcrumbs": `Atpaka\u{13C}ce\u{13C}i`
};


export {$d700c23c0c1b247b$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
